import { Statistic } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { formatTime } from "../../utils/helpers";

const CountUpTimer = ({ startDate, active = true, color, fontSize = 15 }) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const start = dayjs(startDate);

    const updateElapsed = () => {
      const now = dayjs();
      const seconds = now.diff(start, "second");
      setElapsed(seconds);
    };

    updateElapsed();

    if (!active) return;

    const interval = setInterval(updateElapsed, 1000);
    return () => clearInterval(interval);
  }, [startDate, active]);

  return (
    <Statistic value={formatTime(elapsed)} valueStyle={{ fontSize, color }} />
  );
};

export default CountUpTimer;
